import React from "react";
import { createRoot } from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "fin-web-components/style.css";
import "./global.css";
import { preventDocumentRubberBand } from "./global/preventDocumentRubberBand";
import { applyViewportFill } from "./utils/viewportFill";

dayjs.locale("zh-cn");
preventDocumentRubberBand();
applyViewportFill();

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: { fontWeightStrong: 500 },
        components: {
          Message: { zIndexPopup: 4000 },
        },
      }}
    >
      <BrowserRouter>
        <AntdApp>
          <App />
        </AntdApp>
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);
